module.exports = __webpack_public_path__ + "static/img/5-3.439c300.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/5-3.jpg
// module id = BDuC
// module chunks = 0